/**
 * Full Screen Loader Component
 * Displays a centered animated loader that covers the entire screen
 */

import { cn } from "@/lib/utils"

interface FullScreenLoaderProps {
  className?: string
}

export function FullScreenLoader({ className }: FullScreenLoaderProps) {
  return (
    <div
      className={cn(
        "fixed inset-0 z-50 flex items-center justify-center bg-background",
        className
      )}
    >
      <div className="loader relative size-12 animate-spin-loader">
        <div className="circle absolute top-0 left-0 size-5 rounded-full bg-primary" />
        <div className="circle absolute top-0 right-0 size-5 rounded-full bg-primary" />
        <div className="circle absolute bottom-0 left-0 size-5 rounded-full bg-primary" />
        <div className="circle absolute right-0 bottom-0 size-5 rounded-full bg-primary" />
      </div>
    </div>
  )
}
